/* EMEA-only component — do not import outside isEMEAStore() guarded paths */
import { Button, Checkbox, Modal } from 'components/core';
import { shouldShowServicePlanDetails } from 'components/ITeroProposal';
import { Styled } from 'components/ITeroTermsConditionsModal';
import { StandardOrderDetailsTableEMEA } from './';
import { downloadPdf } from 'components/ITeroTermsConditionsModal/ITeroTermsConditionsModal.helper';
import ContactInfoTable from 'components/ITeroTermsConditionsModalEMEA/ContactInfoTable';
import { ITeroTermsConditionsModalEMEAProps } from 'components/ITeroTermsConditionsModalEMEA/ITeroTermsConditionsModalEMEA.type';
import ServicePlanDetailsEMEA from 'components/ITeroTermsConditionsModalEMEA/ServicePlanDetailsEMEA';
import { MdClose } from 'react-icons/md';
import handleITeroCustomerNeeds from 'utils/handleITeroCustomerNeeds';
import EmeaContracts from './EmeaContracts';
import { RentalOrderDetailsTableEMEA } from './';

const ITeroTermsConditionsModalEMEA = ({
  setIsLoading,
  legalTextRef,
  doctorProfile,
  additionalOrderInfo,
  localUserTime,
  i18n,
  onClose,
  currentProposal,
  selectedBillingAddress,
  selectedShippingAddress,
  isMultipleScannerSubscriptions,
  paymentOption,
  contentful,
  lastElement,
  isLoading,
  onAcceptHandler,
  isButtonEnabled,
  isReadOnlyUser,
}: ITeroTermsConditionsModalEMEAProps) => {
  const { isServiceTermHideRequired, isRental } = handleITeroCustomerNeeds(
    currentProposal,
    contentful?.contentfulEnvVariables
  );

  return (
    <Modal overlaysize={'large'}>
      <Styled.Container>
        <Styled.TitleContainer>
          <Styled.LinkTag
            onClick={() =>
              downloadPdf(
                'PREVIEW',
                setIsLoading,
                legalTextRef,
                doctorProfile,
                additionalOrderInfo,
                localUserTime,
                i18n
              )
            }
          >
            {i18n['Preview']}
          </Styled.LinkTag>
          <Styled.CloseButton onClick={onClose}>
            <MdClose size={20} />
          </Styled.CloseButton>
        </Styled.TitleContainer>
        <Styled.LegalTextContainer ref={legalTextRef}>
          <div>
            <Styled.Title>{i18n['iTERO ORDER FORM - EMEA']}</Styled.Title>
            <p>
              {i18n['This iTero Order Form ("Order Form") - EMEA'].replace(
                '{Entity}',
                currentProposal.entityName
              )}
            </p>
            <ContactInfoTable
              additionalOrderInfo={additionalOrderInfo}
              doctorProfile={doctorProfile}
              selectedBillingAddress={selectedBillingAddress}
              selectedShippingAddress={selectedShippingAddress}
            />
            <p>
              <u>
                {i18n['Order Details']} ({currentProposal.proposalName})
              </u>
            </p>
            {isRental ? (
              <RentalOrderDetailsTableEMEA currentProposal={currentProposal} />
            ) : (
              <StandardOrderDetailsTableEMEA
                currentProposal={currentProposal}
                isServiceTermHideRequired={isServiceTermHideRequired}
              />
            )}
            {shouldShowServicePlanDetails(currentProposal) && (
              <ServicePlanDetailsEMEA
                currentProposal={currentProposal}
                isMultipleScannerSubscriptions={isMultipleScannerSubscriptions}
                i18n={i18n}
              />
            )}
            {isRental && (
              <>
                <br />
                <Styled.FormCheckboxContainer>
                  {i18n['Scanner Rental Payment Options']}:
                  <Checkbox
                    label={currentProposal.lineitems[0].servicePlan}
                    onChange={() => ({})}
                    checked={true}
                    disabled
                    style={{ color: 'black' }}
                  />
                </Styled.FormCheckboxContainer>
              </>
            )}
            <Styled.FormCheckboxContainer>
              {i18n['Payment Options']}:
              <Checkbox
                label={paymentOption}
                onChange={() => ({})}
                checked={true}
                disabled
                style={{ color: 'black' }}
              />
            </Styled.FormCheckboxContainer>
            <h3>{i18n['Promotion Specific Details:']}</h3>
            <p style={{ fontStyle: 'italic', fontWeight: 'bolder' }}>
              {i18n['Existing Scanner Promotion:']}
            </p>
            <div data-testid="trade-in-details">{i18n['Trade-In Details']}</div>
            <div data-testid="scanner-model">
              {i18n['Scanner model:']} {currentProposal.scannerModel}
            </div>
            <div data-testid="serial-number">
              {i18n['Serial number:']} {currentProposal.tradeInSerialNumber}
            </div>
            <div data-testid="service-plan-discount">
              {i18n['Service Plan Discount:']}{' '}
              {currentProposal.servicePlanDiscount}
            </div>
            <p style={{ fontStyle: 'italic', fontWeight: 'bolder' }}>
              {i18n['For iTero Sales and Ops Use Only:']}
            </p>
            <div data-testid="funding-source">
              {i18n['Funding Source:']} {paymentOption}
            </div>
            {/* cover strings with i18n for EMEA */}
            <div data-testid="opportunity-number">
              {i18n['Opportunity Number:']} {currentProposal.opportunityNumber}
            </div>
            <div data-testid="authorized-sales-agent">
              {i18n['Authorized Sales Agent or Representative:']}{' '}
              {currentProposal.opportunityOwnerName}
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html:
                  i18n['Service Plan Auto-Renewal Notice & Acknowledgement'],
              }}
            />
            <EmeaContracts
              contentful={contentful}
              doctorProfile={doctorProfile}
              i18n={i18n}
            />
            <div ref={lastElement}></div>
          </div>
        </Styled.LegalTextContainer>
        {isLoading && (
          <Styled.LoadingOverlay>
            <Styled.PDFLoadingSpinner
              isPrimary={true}
              width={'40px'}
              height={'40px'}
            />
          </Styled.LoadingOverlay>
        )}
      </Styled.Container>
      <Styled.ButtonWrapper>
        <Button
          size="md"
          onClick={onAcceptHandler}
          disabled={!isButtonEnabled || isReadOnlyUser}
        >
          {i18n['I ACKNOWLEDGE AND AGREE - EMEA']}
        </Button>
      </Styled.ButtonWrapper>
    </Modal>
  );
};

export default ITeroTermsConditionsModalEMEA;
